export const replaceImageUrl = (url?: string | null): string => {
  return url || "";
};
